var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, LocationOn as LocationIcon, Search as SearchIcon, } from "@mui/icons-material";
import { Alert, Box, Button, Card, Chip, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, Grid, InputAdornment, MenuItem, Pagination, Paper, Slider, Stack, TextField, Typography, } from "@mui/material";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSearchVenues } from "../api/VenueApiProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
var Venues = function () {
    var navigate = useNavigate();
    var location = useLocation();
    var queryParams = new URLSearchParams(location.search);
    var currentSearchTerm = queryParams.get("q") || "";
    var currentPage = Number.parseInt(queryParams.get("page") || "1");
    var currentLat = queryParams.get("lat")
        ? Number.parseFloat(queryParams.get("lat"))
        : undefined;
    var currentLng = queryParams.get("lng")
        ? Number.parseFloat(queryParams.get("lng"))
        : undefined;
    var currentRadius = queryParams.get("radius")
        ? Number.parseFloat(queryParams.get("radius"))
        : undefined;
    var currentOrdering = queryParams.get("ordering") ||
        "relevance";
    var _a = __read(useState(currentSearchTerm), 2), searchTerm = _a[0], setSearchTerm = _a[1];
    var _b = __read(useState(currentLat), 2), lat = _b[0], setLat = _b[1];
    var _c = __read(useState(currentLng), 2), lng = _c[0], setLng = _c[1];
    var _d = __read(useState(currentRadius), 2), radius = _d[0], setRadius = _d[1];
    var _e = __read(useState(currentOrdering), 2), ordering = _e[0], setOrdering = _e[1];
    var _f = __read(useState(false), 2), locationPermissionDialog = _f[0], setLocationPermissionDialog = _f[1];
    // Distance slider values - evenly spaced marks
    var distanceMarks = [
        { value: 0, label: "1" },
        { value: 1, label: "5" },
        { value: 2, label: "10" },
        { value: 3, label: "30" },
        { value: 4, label: "100" },
        { value: 5, label: "All" },
    ];
    var getDistanceValue = function (radius) {
        if (!radius)
            return 5; // Default to All
        if (radius === 1)
            return 0;
        if (radius === 5)
            return 1;
        if (radius === 10)
            return 2;
        if (radius === 30)
            return 3;
        if (radius === 100)
            return 4;
        return 5; // All for any other value
    };
    var getRadiusFromSlider = function (value) {
        var radiusMap = [1, 5, 10, 30, 100, undefined]; // undefined means no radius limit (All)
        return radiusMap[value];
    };
    // Always search to show results (first page when no criteria)
    var hasSearchCriteria = Boolean(currentSearchTerm) || Boolean(currentLat && currentLng);
    var _g = useSearchVenues({
        query: currentSearchTerm || undefined,
        lat: currentLat,
        lng: currentLng,
        radius: currentRadius,
        ordering: currentOrdering,
        enabled: true,
    }), searchResults = _g.data, isLoading = _g.isLoading, isError = _g.isError;
    var venues = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.results) || [];
    var pageCount = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.pageCount) || 0;
    var count = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.count) || 0;
    var handlePageChange = function (_event, value) {
        var params = new URLSearchParams();
        if (currentSearchTerm)
            params.set("q", currentSearchTerm);
        if (currentLat)
            params.set("lat", currentLat.toString());
        if (currentLng)
            params.set("lng", currentLng.toString());
        if (currentRadius !== undefined)
            params.set("radius", currentRadius.toString());
        if (currentOrdering !== "relevance")
            params.set("ordering", currentOrdering);
        params.set("page", value.toString());
        navigate("/venues?".concat(params.toString()));
    };
    var handleSearch = function () {
        var params = new URLSearchParams();
        if (searchTerm.trim())
            params.set("q", searchTerm.trim());
        if (lat !== undefined)
            params.set("lat", lat.toString());
        if (lng !== undefined)
            params.set("lng", lng.toString());
        if (radius !== undefined)
            params.set("radius", radius.toString());
        if (ordering !== "relevance")
            params.set("ordering", ordering);
        navigate("/venues?".concat(params.toString()));
    };
    var requestLocationPermission = function (callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLat(position.coords.latitude);
                setLng(position.coords.longitude);
                setLocationPermissionDialog(false);
                callback === null || callback === void 0 ? void 0 : callback();
            }, function () {
                setLocationPermissionDialog(true);
            });
        }
        else {
            setLocationPermissionDialog(true);
        }
    };
    var handleOrderingChange = function (newOrdering) {
        if (newOrdering === "distance" && (!lat || !lng)) {
            // Need location for distance ordering
            requestLocationPermission(function () {
                setOrdering(newOrdering);
            });
        }
        else {
            setOrdering(newOrdering);
        }
    };
    var handleDistanceChange = function (newDistance) {
        if (newDistance !== undefined && (!lat || !lng)) {
            // Need location for distance filtering
            requestLocationPermission(function () {
                setRadius(newDistance);
            });
        }
        else {
            setRadius(newDistance);
        }
    };
    var handleLocationPermissionDecline = function () {
        setLocationPermissionDialog(false);
        // Reset to relevance ordering if distance was selected
        if (ordering === "distance") {
            setOrdering("relevance");
        }
        // Reset to All radius if a specific distance was selected
        if (radius !== undefined) {
            setRadius(undefined);
        }
    };
    var handleVenueClick = function (venueId) {
        navigate("/venues/".concat(venueId));
    };
    if (isLoading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(Container, { maxWidth: "lg", sx: { py: 4 }, children: [_jsx(ErrorSnackbar, { open: !!isError, message: "Failed to search venues!" }), _jsxs(Box, { sx: {
                    mb: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, children: "Venues" }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: "Search Log.Soccer's venue database" })] }), _jsx(Button, { variant: "contained", startIcon: _jsx(AddIcon, {}), component: Link, to: "/venues/create", sx: { display: { xs: "none", sm: "flex" } }, children: "Add Venue to Log.Soccer" })] }), _jsxs(Alert, { severity: "info", sx: {
                    mb: 4,
                    "& .MuiAlert-message": {
                        width: "100%",
                    },
                    "& .MuiAlert-icon": {
                        alignSelf: "flex-start",
                        mt: 0.5,
                    },
                }, children: [_jsx(Typography, { variant: "subtitle1", gutterBottom: true, sx: { fontWeight: 600 }, children: "The Log.Soccer Venue Database" }), _jsx(Typography, { variant: "body2", sx: { lineHeight: 1.6 }, children: "Each soccer venue is shared globally across all users. Once a venue is added, anyone can schedule matches, training sessions, and events there. Whether it's a local park pitch, professional stadium, or training facility - these shared venues make it easier for the entire soccer community to organize and play." })] }), _jsx(Paper, { sx: { p: 3, mb: 4 }, children: _jsxs(Stack, { spacing: 3, children: [_jsxs(Box, { sx: { display: "flex", gap: 2, alignItems: "center" }, children: [_jsx(TextField, { fullWidth: true, label: "Search Log.Soccer venues", placeholder: "Search by name or address...", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, InputProps: {
                                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchIcon, { color: "action" }) })),
                                    }, onKeyDown: function (e) {
                                        if (e.key === "Enter") {
                                            handleSearch();
                                        }
                                    } }), _jsx(Button, { variant: "contained", onClick: handleSearch, sx: { height: 56 }, children: "Search" })] }), _jsxs(Grid, { container: true, spacing: 2, alignItems: "center", children: [_jsxs(Grid, { item: true, xs: 12, sm: 6, md: 6, children: [_jsxs(Typography, { gutterBottom: true, children: ["Distance (", getDistanceValue(radius) === 5
                                                    ? "All"
                                                    : "".concat(getRadiusFromSlider(getDistanceValue(radius)), " miles"), ")"] }), _jsx(Slider, { value: getDistanceValue(radius), onChange: function (_, value) {
                                                return handleDistanceChange(getRadiusFromSlider(value));
                                            }, marks: distanceMarks, step: null, min: 0, max: 5, valueLabelDisplay: "off" })] }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsxs(TextField, { fullWidth: true, select: true, label: "Sort by", value: ordering, onChange: function (e) {
                                            return handleOrderingChange(e.target.value);
                                        }, children: [_jsx(MenuItem, { value: "relevance", children: "Relevance" }), _jsx(MenuItem, { value: "distance", children: "Distance" }), _jsx(MenuItem, { value: "name", children: "Name" })] }) })] })] }) }), count === 0 ? (_jsxs(Card, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Typography, { variant: "h6", color: "text.secondary", gutterBottom: true, children: "No venues found" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 3 }, children: hasSearchCriteria
                            ? "No venues match your search criteria. Try adjusting your search terms or location."
                            : "No venues have been added yet. Be the first to add a venue to the database!" }), _jsx(Button, { variant: "contained", startIcon: _jsx(AddIcon, {}), component: Link, to: "/venues/create", size: "large", children: "Add Venue to Log.Soccer" })] })) : (_jsxs(Paper, { children: [venues.map(function (venue, index) { return (_jsx(Box, { sx: {
                            p: 3,
                            bgcolor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                            borderBottom: "1px solid #ddd",
                            cursor: "pointer",
                            transition: "background-color 0.2s ease",
                            "&:hover": {
                                bgcolor: "#f0f7ff",
                            },
                        }, onClick: function () { return handleVenueClick(venue.id); }, children: _jsxs(Grid, { container: true, spacing: 2, alignItems: "center", children: [_jsxs(Grid, { item: true, xs: 12, md: 8, children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: venue.name }), _jsxs(Box, { sx: { display: "flex", alignItems: "flex-start", mb: 1 }, children: [_jsx(LocationIcon, { color: "action", sx: { mr: 1, mt: 0.5, fontSize: 20 } }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: venue.formattedAddress })] })] }), _jsx(Grid, { item: true, xs: 12, md: 4, children: _jsxs(Box, { sx: {
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: 1,
                                            flexWrap: "wrap",
                                        }, children: [_jsx(Chip, { size: "small", label: "Active", color: "success", variant: "outlined" }), venue.distance && (_jsx(Chip, { size: "small", label: "".concat(Number.parseFloat(venue.distance).toFixed(1), " mi"), color: "primary", variant: "outlined" })), _jsxs(Typography, { variant: "caption", color: "text.secondary", sx: { alignSelf: "center" }, children: ["Added ", new Date(venue.createdAt).toLocaleDateString()] })] }) })] }) }, venue.id)); }), _jsx(Box, { sx: { display: "flex", justifyContent: "center", p: 2 }, children: _jsx(Pagination, { showFirstButton: true, showLastButton: true, count: Math.max(pageCount, 1), page: currentPage, onChange: handlePageChange }) })] })), _jsx(Fab, { color: "primary", sx: {
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    display: { xs: "flex", sm: "none" },
                }, component: Link, to: "/venues/create", children: _jsx(AddIcon, {}) }), _jsxs(Dialog, { open: locationPermissionDialog, onClose: handleLocationPermissionDecline, children: [_jsx(DialogTitle, { children: "Location Permission Required" }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: "To sort by distance or filter by radius, we need access to your location. This helps us show you venues nearest to you. Your location is only used for this search and is not stored." }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleLocationPermissionDecline, color: "inherit", children: "No Thanks" }), _jsx(Button, { onClick: function () { return requestLocationPermission(); }, variant: "contained", children: "Allow Location" })] })] })] }));
};
export default Venues;
